export enum CostItemField {
  Ipi = 'domain.enums.item_field_calculate.ipi',
  TaxReplacement = 'domain.enums.item_field_calculate.tax_replacement',
  Freight = 'domain.enums.item_field_calculate.freight',
  Accessory = 'domain.enums.item_field_calculate.accessory',
  FixedCost = 'domain.enums.item_field_calculate.fixed_cost',
  Icms = 'domain.enums.item_field_calculate.icms',
  Operational = 'domain.enums.item_field_calculate.operational',
  CalculateProfitMargin = 'domain.enums.item_field_calculate.profit_margin',
}

export enum CostItemsFieldsEnum {
  ipi = 1,
  taxReplacement = 2,
  freight = 4,
  accessory = 8,
  fixedCost = 16,
  icms = 32,
  operational = 64,
  profitMargin = 128,
}

export const CostItemsFieldsOptions = {
  [CostItemsFieldsEnum.ipi]: 'ipi',
  [CostItemsFieldsEnum.taxReplacement]: 'tax_replacement',
  [CostItemsFieldsEnum.freight]: 'freight',
  [CostItemsFieldsEnum.accessory]: 'accessory',
  [CostItemsFieldsEnum.fixedCost]: 'fixed_cost',
  [CostItemsFieldsEnum.icms]: 'icms',
  [CostItemsFieldsEnum.operational]: 'operational',
  [CostItemsFieldsEnum.profitMargin]: 'profit_margin',
};

export interface CostItem {
  field: CostItemsFieldsEnum;
  active: boolean;
}

export interface CompanyStockConfiguration {
  result: {
    company: {
      id: number;
      name: string;
    };
    costItems: CostItem[];
    fixedCost: number;
    fixedProfitMargin: number;
  };
}

export interface UpdateCompanyStockConfigurationRequest {
  companyId: number;
  costItems: {
    field: string;
    active: boolean;
  }[];
  fixedCost: number;
  fixedProfitMargin: number;
}

export interface CompanyStockConfigurationCostItemCreateRequest {
  companyId: number;
  costItems: {
    field: CostItemsFieldsEnum;
    active: boolean;
  }[];
}

export interface CompanyStockConfigurationFixedCostCreateRequest {
  companyId: number;
  fixedCost: number;
}

export interface CompanyStockConfigurationProfitMarginCreateRequest {
  companyId: number;
  fixedProfitMargin: number;
  hasNeedRecalculateStock: boolean;
}

export enum PartItemFieldOption {
  BarCode = 'domain.enums.item_field_options.bar_code',
  ManufacturingCode = 'domain.enums.item_field_options.manufacturing_code',
  OriginalCode = 'domain.enums.item_field_options.original_code',
  Description = 'domain.enums.item_field_options.description',
  AvailableStock = 'domain.enums.item_field_options.available_stock',
  TotalStock = 'domain.enums.item_field_options.total_stock',
  Manufacturer = 'domain.enums.item_field_options.manufacturer',
  Group = 'domain.enums.item_field_options.group',
  SellPrice = 'domain.enums.item_field_options.sell_price',
  companyCode = 'domain.enums.item_field_options.company_code',
  location = 'domain.enums.item_field_options.location',
  image = 'domain.enums.item_field_options.image',
  applications = 'domain.enums.item_field_options.applications',
}

export enum PartItemFieldsEnum {
  BarCode = 1,
  ManufacturingCode = 2,
  OriginalCode = 4,
  Description = 8,
  AvailableStock = 16,
  TotalStock = 32,
  Manufacturer = 64,
  Group = 128,
  SellPrice = 256,
  companyCode = 512,
  location = 1024,
  image = 2048,
  applications = 4096,
}

export const PartItemFieldOptions = {
  [1]: PartItemFieldOption.BarCode,
  [2]: PartItemFieldOption.ManufacturingCode,
  [4]: PartItemFieldOption.OriginalCode,
  [8]: PartItemFieldOption.Description,
  [16]: PartItemFieldOption.AvailableStock,
  [32]: PartItemFieldOption.TotalStock,
  [64]: PartItemFieldOption.Manufacturer,
  [128]: PartItemFieldOption.Group,
  [256]: PartItemFieldOption.SellPrice,
  [512]: PartItemFieldOption.companyCode,
  [1024]: PartItemFieldOption.location,
  [2048]: PartItemFieldOption.image,
  [4096]: PartItemFieldOption.applications,
};

export interface PartColumnField {
  field: PartItemFieldsEnum;
  active: boolean;
}

export interface PartConfigurationProfile {
  nextToken: number;
  result: PartColumnField[];
}

export interface UpdatePartConfigurationProfileRequest {
  fields: PartColumnField[];
}

export interface CompositionPriceFormInterface {
  ipi: boolean;
  tax_replacement: boolean;
  freight: boolean;
  accessory: boolean;
  fixed_cost: boolean;
  icms: boolean;
  operational: boolean;
  profit_margin: boolean;
}
